export default {"src":"/_next/static/media/1.66f50fb0.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};